import * as constants from './definitions.constants'
import { ActionCreator } from 'redux'
import { ISetDefinitionsAction } from 'src/redux/definitions/definitions.types'

export const setDefinitions: ActionCreator<
  ISetDefinitionsAction
> = definitions => ({
  type: constants.SET_DEFINITIONS,
  payload: definitions,
})
